
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { PlanInterface, PlanRepositoryInterface } from '@/services/Plan/interfaces';
import { WebsiteGroup } from '@/services/WebsiteGroup/interfaces';
import { Website } from '@/services/Website/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'planRepository',
    'systemUserRepository',
  ],
})
export default class ChangePlanDialog extends Vue {
  @Prop() group!: WebsiteGroup;

  @Prop() mainWebsite!: Website;

  public visible: boolean = true;

  public loading: boolean = true;

  public planRepository!: PlanRepositoryInterface;

  public plans: PlanInterface[] = [];

  public newPlanId: number = 0;

  public get valid(): boolean {
    return this.newPlanId !== this.group.plan;
  }

  public getPlanName(id: number): string {
    const plan = this.plans.find((p) => p.id === id);
    if (!plan) {
      return 'N/A';
    }

    return plan.name;
  }

  public checkDisabledItem(plan: PlanInterface): boolean {
    return plan.id === this.group.plan;
  }

  public async created(): Promise<void> {
    try {
      this.plans = await this.planRepository.getAll();
      this.newPlanId = this.group.plan;

      this.loading = false;
    } catch (err) {
      this.$errorDialog.show('Failed to fetch plans, please try again later!');
    }
  }

  public async changePlan(): Promise<void> {
    this.$emit('changePlan', this.newPlanId);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.$emit('close');
    this.visible = false;
    this.loading = true;
  }
}
